import { useQuery } from "@tanstack/react-query";
import { getBundlesData } from "../repositories/bundlesRepository";
import { BundleRow } from "../models/types";

interface UseBundlesDataProps {
	startDate: Date | null;
	endDate: Date | null;
	onError?: (error: Error) => void;
}

export const useBundlesData = ({
	startDate,
	endDate,
	onError,
}: UseBundlesDataProps) => {
	const enabled = !!(startDate && endDate);

	const { data, isLoading, refetch } = useQuery<BundleRow[], Error>({
		queryKey: [
			"bundlesData",
			startDate?.toISOString() ?? null,
			endDate?.toISOString() ?? null,
		],
		queryFn: () => getBundlesData(startDate as Date, endDate as Date),
		enabled,
		refetchInterval: 60000,
		onError,
	});

	return {
		rows: data ?? [],
		isLoading: enabled && isLoading,
		refetch,
	};
};
